import { AssetDto, AssetImageTypeDataDto } from '@nusign/picflow-backend-types';
import { getCaptureTime } from '../../lib/extract-exif';
import { seededRandom } from '../../lib/seeded-random';
import { simplifiedAssetNames } from '../../lib/simplified-asset-names';

const sortAlphaNum = (a, b) => a.localeCompare(b, 'en', { numeric: true });

export const sortAssetSection = (assets: AssetDto[], sortBy = 'manual'): AssetDto[] => {
  if (!sortBy) sortBy = 'manual';

  const inverted = sortBy.startsWith('-');
  if (inverted) sortBy = sortBy.slice(1);

  const sortedAssets = assets.slice();

  if (sortBy === 'capture_time') {
    const captureTimes = new Map();
    assets.forEach(asset => {
      const data = <AssetImageTypeDataDto>asset.version_data?.data;
      captureTimes.set(asset.id, getCaptureTime(data?.exif));
    });
    sortedAssets.sort((a, b) => sortAlphaNum(a.id, b.id)); // sort by id to keep order of equal values
    sortedAssets.sort(
      (a, b) =>
        (captureTimes.get(a.id) || a.version_data.created_at) - (captureTimes.get(b.id) || b.version_data.created_at)
    );
  }
  if (sortBy === 'created_at') {
    sortedAssets.sort((a, b) => sortAlphaNum(a.id, b.id)); // sort by id to keep order of equal values
    sortedAssets.sort((a, b) => a.version_data.created_at - b.version_data.created_at);
  }
  if (sortBy === 'asset_name') {
    const simplifiedNames = simplifiedAssetNames(assets);
    sortedAssets.sort((a, b) => sortAlphaNum(simplifiedNames[a.id], simplifiedNames[b.id]));
  }

  if (sortBy === 'manual') sortedAssets.sort((a, b) => a.position - b.position);

  if (sortBy.startsWith('random')) {
    const extra = sortBy.split('|')[1];
    const randomMap = new Map();
    assets.forEach(asset => {
      randomMap.set(asset.id, seededRandom(asset.id + extra));
    });
    sortedAssets.sort((a, b) => randomMap.get(a.id) - randomMap.get(b.id));
  }

  if (inverted) sortedAssets.reverse();
  return sortedAssets;
};
